var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"state":_vm.s && _vm.v.$invalid ? false : null,"invalid-feedback":_vm.invalidFeedback}},[_c('div',{staticClass:"financial-data"},[_vm._v(_vm._s(_vm.$n(_vm.value, 'money', 'de-DE')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }